'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/23.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapLikePageComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MapLikePageComponent, _Component);

  function MapLikePageComponent() {
    (0, _classCallCheck3.default)(this, MapLikePageComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(MapLikePageComponent).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(MapLikePageComponent, [{
    key: 'render',
    value: function render() {
      var styles = require('./MapLikePageComponent.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'span',
          { className: styles.a1 },
          '新疆'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a2 },
          '甘肃'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a3 },
          '青海'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a4 },
          '西藏'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a5 },
          '云南'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a6 },
          '四川'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a7 },
          '陕西'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a8 },
          '宁夏'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a9 },
          '内蒙古'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a10 },
          '山西'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a11 },
          '河南'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a12 },
          '湖北'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a13 },
          '重庆'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a14 },
          '贵州'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a15 },
          '广西'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a16 },
          '海南'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a17 },
          '广东'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a18 },
          '香港'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a19 },
          '湖南'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a20 },
          '江西'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a21 },
          '福建'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a22 },
          '台湾'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a23 },
          '浙江'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a24 },
          '安徽'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a25 },
          '江苏'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a26 },
          '山东'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a27 },
          '河北'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a28 },
          '天津'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a29 },
          '北京'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a30 },
          '辽宁'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a31 },
          '吉林'
        ),
        _react2.default.createElement(
          'span',
          { className: styles.a32 },
          '黑龙江'
        )
      );
    }
  }]);
  return MapLikePageComponent;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object
}, _temp);
exports.default = MapLikePageComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MapLikePageComponent/MapLikePageComponent.js
 ** module id = 1371
 ** module chunks = 0
 **/